import { ApiError } from "../api/client";
import i18n from "../i18n";

export function formatScanApiError(err: unknown): string {
  if (err instanceof ApiError) {
    const code = (err.body as { error?: string } | undefined)?.error;
    if (err.status === 404 && code === "code_not_recognized") {
      return i18n.t("visitor.scan_code_not_found");
    }
    if (err.status === 403) {
      return i18n.t("visitor.scan_no_access");
    }
    if (err.status === 401) {
      return i18n.t("visitor.scan_session_expired");
    }
  }
  if (err instanceof Error) {
    return err.message;
  }
  return i18n.t("scan.err_generic");
}
